﻿import banner from "./banner";
import features from "./features";
import "postMessage";

export default {
	banner: banner,
	features: features
}